import { AccountRecord, CollateralHistoryViewRecord } from '@tassat/fred-definitions';
import { CollateralHistoryViewRecordExtended } from '@tassat/fred-extended-definitions';
import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';

import {
    getAccounts,
    getPledgeList,
    getSelectedAccountId
} from './common';

const getPledgeId = (_state: AdminState | ClientState, pledgeId: string) => pledgeId;

export const getPledgeById = createSelector([ getPledgeList, getPledgeId ], (pledges, pledgeId) => {
    return pledges[pledgeId];
});

export const clientPledgesMapping = createSelector(
    [ getPledgeList, getAccounts, getSelectedAccountId ],
    (pledgeList, accounts, selectedAccountId) => {
        const pledges: CollateralHistoryViewRecordExtended[] = Object.keys(pledgeList)
            .map(id => pledgeList[id]);

        const selectedAccount: AccountRecord = accounts[selectedAccountId];

        return pledges;

        // return transactions.filter(tx => {
        //     if (
        //         tx.type === TransactionTypeChar.deposit ||
        //         tx.type === TransactionTypeChar.order ||
        //         tx.type === TransactionTypeChar.int_distribution ||
        //         tx.type === TransactionTypeChar.withdrawal
        //     ) {
        //         return true;
        //     }
        //     if (selectedAccount && selectedAccount.Account === tx.PledgingAccountAddress && tx.type !== TransactionTypeChar.send) {
        //         return false;
        //     }

        //     if (selectedAccount && selectedAccount.Account === tx.RecipientAddress && tx.type !== TransactionTypeChar.receive) {
        //         return false;
        //     }

        //     if (!selectedAccount && tx.type === TransactionTypeChar.receive
        //         && pledgeList[`${tx.RequestId}-${TransactionTypeChar.send}`]) {
        //         return false;
        //     }

        //     return true;
        // });
    }
);

export const adminPledgesMapping = createSelector([getPledgeList], (pledgeList) => {
    const pledges: CollateralHistoryViewRecord[] = Object.keys(pledgeList)
        .map(id => pledgeList[id]);

    return pledges;
});